var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { LottieIcon } from '..';
import { getColor } from '../helpers/ColorHelpers';
import { ImgThemeConsumer, styled } from '../theme/ThemeHelpers';
import { DimmerContainer, DimmerContentContainer } from './Dimmer';
var LottieContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: ", ";\n    max-width: 800px;\n    margin:auto;\n    text-align: center;\n    font-size: 1.2rem;\n    font-weight: bold;\n    color: #000;    \n    *{\n            fill: ", ";\n            stroke: ", ";\n    }\n"], ["\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: ", ";\n    max-width: 800px;\n    margin:auto;\n    text-align: center;\n    font-size: 1.2rem;\n    font-weight: bold;\n    color: #000;    \n    *{\n            fill: ", ";\n            stroke: ", ";\n    }\n"])), function (props) { return props.size === "small" ? "200px" : "80%"; }, function (p) { var _a; return getColor(p, (_a = p.color) !== null && _a !== void 0 ? _a : "@accent"); }, function (p) { var _a; return getColor(p, (_a = p.color) !== null && _a !== void 0 ? _a : "@accent"); });
var Loader = /** @class */ (function (_super) {
    __extends(Loader, _super);
    function Loader(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            active: props.active ? props.active : false,
            initial: true,
        };
        return _this;
    }
    Loader.prototype.componentDidUpdate = function (prevProps, prevState) {
        var active = this.props.active;
        if (prevState.active !== active) {
            this.setState({ active: active ? active : false, initial: false });
        }
    };
    Loader.prototype.render = function () {
        var _this = this;
        var _a = this.state, active = _a.active, initial = _a.initial;
        var onClick = this.props.onClick;
        return (React.createElement(ImgThemeConsumer, null, function (theme) {
            var _a, _b, _c;
            var animation = _this.props.animation ? "images/lottiIcons/" + _this.props.animation + ".json" : "images/lottiIcons/imgloader.json";
            return (React.createElement(DimmerContainer, { active: active, initial: initial, onClick: onClick },
                React.createElement(DimmerContentContainer, { light: (_a = _this.props.light) !== null && _a !== void 0 ? _a : false },
                    React.createElement(LottieContainer, { size: (_b = _this.props.size) !== null && _b !== void 0 ? _b : "large", color: _this.props.color },
                        React.createElement(LottieIcon, { url: animation, speed: 1, autoplay: true, loop: true }), (_c = _this.props.infoText) !== null && _c !== void 0 ? _c : undefined,
                        _this.props.children))));
        }));
    };
    return Loader;
}(React.PureComponent));
export default Loader;
var templateObject_1;
//# sourceMappingURL=Loader.js.map